<div class="education-container">
  <!-- Common Filter Component -->
  <app-common-filter [config]="filterConfig" [role]="role" [plan]="plan" [error]="error"
    [preselectedUniversity]="preselectedUniversity" (filterChange)="onFilterChange($event)"
    (analyzeClick)="onAnalyzeClick($event)">
  </app-common-filter>

  <!-- Results Section -->
  @if(table && table.length > 0){
  <div class="results-section">
    <h3>Analysis Results</h3>
    <p>Found {{ table.length }} universities for analysis</p>
    <!-- Add your results display here -->
  </div>
  }

  <!-- Common Tabs Component -->
  <!-- <p>category: {{category}}</p> -->
  <app-common-tabs [config]="tabsConfig" [role]="role" [plan]="plan" [selectedEntities]="selectedEntities"
    [category]="category" [country]="country" (tabChange)="onTabChange($event)" (reloadTab)="onReloadTab($event)"
    (visualizationChange)="onVisualizationChange($event)">
  </app-common-tabs>
</div>
